import { translate } from "app/filters/i18nFilter";
import { GranularityNames } from "app/UtilitiesAndConstants/Constants/Moment";

import type { ITimeGranularityFilterItem } from "./types";

export const INCLUDE_SUBDOMAINS = "includeSubDomains";
export const VERIFIED_DATA = "ShouldGetVerifiedData";
export const TIME_GRANULARITY = "timeGranularity";
export const UNBOUNCED_VISITS = "unBounced";
export const ORDER_BY = "orderBy";
export const INCLUDE_EXCLUDE_KEYWORDS = "multiIncludeExcludeKeywords";
export const INCLUDE_EXCLUDE_URL = "multiIncludeExcludeUrl";
export const INCLUDE_EXCLUDE_TITLE = "multiIncludeExcludeTitle";
export const AD_TYPE = "adType";
export const SELECTED_CATEGORY = "selectedCategory";
export const DOMAINS = "domains";
const { DAILY, WEEKLY, MONTHLY } = GranularityNames;

export const getTimeGranularityItems = (
    isDisabledRecord = { daily: false, weekly: false, monthly: false },
): ITimeGranularityFilterItem[] => [
    {
        id: DAILY,
        text: DAILY,
        disabled: isDisabledRecord.daily,
    },
    {
        id: WEEKLY,
        text: WEEKLY,
        disabled: isDisabledRecord.weekly,
    },
    { id: MONTHLY, text: MONTHLY, disabled: isDisabledRecord.monthly },
];

export const getBooleanFilterItems = () => [
    { id: "true", text: translate("global.yes") },
    { id: "false", text: translate("global.no") },
];
